import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FileDown, Sheet } from "lucide-react";
import { toast } from "sonner";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { exportReport } from "../../api/acctExport";
import { useApiError } from "../../hooks/useApiError";

const REPORTS = ["trial-balance", "income-statement", "balance-sheet", "equity-changes", "cash-flow", "aging", "segments"];

// PDF (company logo + Arabic RTL) and Excel export for every official statement.
export const ExportBar = ({ range }) => {
  const { t, i18n } = useTranslation();
  const describe = useApiError();
  const [busy, setBusy] = useState("");

  const run = async (report, format) => {
    setBusy(`${report}-${format}`);
    try {
      await exportReport(report, format, range, i18n.language);
      toast.success(t("acct.exportDone"));
    } catch (error) {
      toast.error(describe(error));
    } finally {
      setBusy("");
    }
  };

  return (
    <NeuCard className="p-4" data-testid="export-bar">
      <p className="label-xs mb-3">{t("acct.exportTitle")}</p>
      <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {REPORTS.map((report) => (
          <div key={report} className="flex items-center gap-2 rounded-2xl px-3 py-2 shadow-neu-in">
            <span className="min-w-0 flex-1 truncate text-xs font-semibold">{t(`acct.exportNames.${report}`)}</span>
            <NeuButton
              className="px-2.5 py-1.5 text-[11px]"
              disabled={busy === `${report}-pdf`}
              data-testid={`export-${report}-pdf`}
              onClick={() => run(report, "pdf")}
            >
              <FileDown className="h-3 w-3" /> PDF
            </NeuButton>
            <NeuButton
              className="px-2.5 py-1.5 text-[11px]"
              disabled={busy === `${report}-xlsx`}
              data-testid={`export-${report}-xlsx`}
              onClick={() => run(report, "xlsx")}
            >
              <Sheet className="h-3 w-3" /> Excel
            </NeuButton>
          </div>
        ))}
      </div>
    </NeuCard>
  );
};
